import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFingerprint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.501 9.396c3.46-5.265 11.13-5.414 14.792-.287l.219.306a.6.6 0 0 0 .976-.697l-.219-.307C16.117 2.598 7.422 2.767 3.5 8.737a.6.6 0 1 0 1.002.66Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.667 10.36c-2.238 0-4.067 1.958-4.067 5.067 0 1.213.39 2.495.948 3.605.563 1.117 1.262 1.992 1.818 2.42a.6.6 0 0 1-.732.95c-.744-.572-1.545-1.614-2.157-2.83C6.86 18.348 6.4 16.88 6.4 15.427c0-3.558 2.17-6.267 5.267-6.267 1.062 0 1.958.163 2.777.66.808.489 1.477 1.265 2.164 2.361a15.397 15.397 0 0 1 .639 1.3 29.76 29.76 0 0 1 .285.662l.017.041.005.012.002.004a.6.6 0 0 1-1.111.454l-.006-.013-.016-.039-.06-.145a28.873 28.873 0 0 0-.212-.49c-.173-.387-.385-.84-.566-1.159-.643-1.023-1.19-1.615-1.763-1.962-.564-.342-1.218-.486-2.155-.486Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.378 14.698a4.555 4.555 0 0 0 4.964 4.289.6.6 0 1 1 .11 1.195 5.755 5.755 0 0 1-6.272-5.419.6.6 0 0 1 1.198-.065Z"
    />
    <path
      fill="#F7A600"
      d="M6.621 4.26a10.886 10.886 0 0 1 10.425 0 .6.6 0 0 0 .575-1.053 12.086 12.086 0 0 0-11.575 0 .6.6 0 1 0 .575 1.053ZM10.767 7.993c2.662-.45 4.807.565 6.442 2.497.92 1.086 1.455 2.472 1.569 3.653.057.59.005 1.095-.13 1.473-.132.373-.33.588-.56.69a.55.55 0 0 0-.031.016c-.566.294-1.054.283-1.462.125-.428-.164-.812-.507-1.093-.935-.222-.337-.363-.713-.527-1.149-.049-.13-.1-.266-.156-.408-.22-.561-.525-1.228-1.15-1.65-1.216-.82-2.874-.823-4.096.414-1.277 1.294-1.147 3.484-.11 5.583.56 1.135 1.645 2.194 2.678 2.967.523.392 1.05.724 1.522.967.45.232.912.416 1.285.45a.6.6 0 0 0 .104-1.196c-.127-.011-.414-.102-.84-.32a9.903 9.903 0 0 1-1.352-.862c-.968-.724-1.882-1.647-2.322-2.538-.964-1.952-.833-3.476-.11-4.208.777-.787 1.786-.791 2.57-.262.293.198.488.545.705 1.095l.12.318c.17.453.373.998.676 1.459.385.584.95 1.12 1.665 1.395.729.28 1.57.271 2.431-.172.595-.273.975-.788 1.184-1.377.21-.588.262-1.28.194-1.99-.137-1.419-.767-3.036-1.848-4.313-1.863-2.201-4.411-3.436-7.558-2.905-2.191.37-4.783 2.028-5.803 5.13-.362 1.1-.497 2.516-.48 3.814.017 1.288.185 2.554.49 3.342a.6.6 0 0 0 1.12-.432c-.23-.592-.394-1.69-.41-2.926-.016-1.228.115-2.498.42-3.423.864-2.627 3.054-4.017 4.863-4.322Z"
    />
  </svg>
);
export default SvgTwoColorFingerprint;
